<ng-container *transloco="let t">
    <p>{{ t('cart.enter_name') }}</p>
    <form [formGroup]="form" class="space-y-2 mt-4" (ngSubmit)="onSubmit()">
        <tui-input formControlName="name" required tuiAutoFocus class="mb-10">
            {{ t('name.label') }}
        </tui-input>

        <div class="flex justify-center">
            <button tuiButton appearance="primary" size="m" type="submit" [disabled]="form.invalid" class="w-full">
                {{ t('confirm') }}
            </button>
        </div>
    </form>
</ng-container>
